import React from 'react';
import { defaultTemplate } from 'core/hoc';
import { HistoryLogTemplate } from 'themes/components';

function MarketplaceOrderHistoryLogListTemplate({ marketplaceOrderHistoryLogViewStore }) {
	const { listStore, order } = marketplaceOrderHistoryLogViewStore;
	return <HistoryLogTemplate order={order} listStore={listStore}></HistoryLogTemplate>;
}

export default defaultTemplate(MarketplaceOrderHistoryLogListTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/order/pages/MarketplaceOrderHistoryLogListTemplate.jsx